import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Container, Row, Col, Button } from "bootstrap-4-react";
import { Link } from "react-router-dom";

import "../../styles/css/ElevationForm/conditionalForm.css";
const userId = localStorage.getItem("userId");

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#ffffff",
    boxShadow: "none",
    color: "#606060",
  },
});
class Questionnaire extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answer1: "",
      answer2: "",
      answer3: "",
      answer4: "",
      answer5: "",
      answer6: "",
      answer7: "",
      answer8: "",
      diagram_no: "",
      answer9: "",
      option: "",
    };
    this.onValueChange1 = this.onValueChange1.bind(this);
    this.onValueChange2 = this.onValueChange2.bind(this);
    this.onValueChange3 = this.onValueChange3.bind(this);
    this.onValueChange4 = this.onValueChange4.bind(this);
    this.onValueChange5 = this.onValueChange5.bind(this);
    this.onValueChange6 = this.onValueChange6.bind(this);
    this.onValueChange7 = this.onValueChange7.bind(this);
    this.onValueChange8 = this.onValueChange8.bind(this);
    this.onValueChange9 = this.onValueChange9.bind(this);

    this.onValueChangeFalse = this.onValueChangeFalse.bind(this);
    this.onSelcetOption = this.onSelcetOption.bind(this);
  }
  onSelcetOption(event) {
    this.setState({
      option: event.target.value,
    });
  }
  onValueChange1(event) {
    this.setState({
      answer1: event.target.value,
    });
  }
  onValueChange2(event) {
    this.setState({
      answer2: event.target.value,
    });
  }
  setStorage = (diagram, diagramdata) => {
    sessionStorage.setItem("diagram", diagram);
    sessionStorage.setItem("diagramdata", JSON.stringify(diagramdata));
  };
  onValueChange3(event) {
    this.setState({
      answer3: event.target.value,
    });
  }
  onValueChange4(event) {
    this.setState({
      answer4: event.target.value,
    });
  }
  onValueChange5(event) {
    this.setState({
      answer5: event.target.value,
    });
  }
  onValueChange6(event) {
    this.setState({
      answer6: event.target.value,
    });
  }
  onValueChange7(event) {
    this.setState({
      answer7: event.target.value,
    });
  }

  onValueChange8(event) {
    this.setState({
      answer8: event.target.value,
    });
  }
  onValueChange9(event) {
    this.setState({
      answer9: event.target.value,
    });
  }
  reset(event) {
    this.setState({
      answer1: event.target.value,
      answer2: event.target.value,
      answer3: event.target.value,
      answer4: event.target.value,
      answer5: event.target.value,
      answer6: event.target.value,
      answer7: event.target.value,
      answer8: event.target.value,
      answer9: event.target.value,
    });
  }
  onValueChangeFalse(event) {
    this.setState({
      answer9: event.target.value,
    });
    this.setState({
      answer1: "",
      answer2: "",
      answer3: "",
      answer4: "",
      answer5: "",
      answer6: "",
      answer7: "",
      answer8: "",
      answer9: "",
    });
  }
  componentDidMount() {
    sessionStorage.clear();
    sessionStorage.setItem("active_section", 1);
  }
  render() {
    return (
      <div>
        <Container className="breadCrubmContainerDashboard">
          <div className="breadCrumb">
            <Link to="/" className="prevLinks">
              Dashboard{" "}
            </Link>{" "}
            <span>&nbsp;&gt;&nbsp;</span>
            <span className="currLink"> Questionnaire </span>{" "}
          </div>{" "}
        </Container>{" "}
        <Container>
          {this.state.option === "" ? (
            <div className="conditional-question-form">
              <div className="main-questionnaire-wrapper">
                <h4>
                  Please select one of the below options and then we can begin
                </h4>
                <p>
                  (Instructions - Option 1 allows you to choose your building
                  diagram and proceed to the elevation form; option 2 requires
                  you to answer a few questions to determine the building
                  diagram and proceed.)
                </p>
                <div class="radio-toolbar">
                  <input
                    type="radio"
                    id="questinnaire"
                    name="option"
                    value="yes"
                    onChange={this.onSelcetOption}
                  />
                  <label for="questinnaire">I 'll answer the questions</label>

                  <input
                    type="radio"
                    id="blockDiagram"
                    name="option"
                    value="no"
                    onChange={this.onSelcetOption}
                  />
                  <label for="blockDiagram">
                    I 'll select my building diagram{" "}
                  </label>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {this.state.option === "yes" ? (
            <div>
              <div className="headerCardRoot">
                <div className="headerCardMain cardHeading">
                  <div className="headerCardTitle">
                    <span> QUESTIONNAIRE </span>{" "}
                  </div>
                </div>
              </div>
              <form className="conditional-question-form">
                <div className="radio-btn-back">
                  <input
                    type="radio"
                    id="radioBack"
                    name="option"
                    value=""
                    onChange={this.onSelcetOption}
                  />
                  <label for="radioBack">Go back</label>
                </div>
                <div>
                  <div className="question-block-label">
                    <label>
                      <ul>
                        <li> Does your building have a basement ? </li>{" "}
                      </ul>{" "}
                    </label>{" "}
                  </div>{" "}
                  <div className="radio-btn-block">
                    <input
                      disabled={
                        this.state.answer2 === "yes" ||
                        this.state.answer2 === "no" ||
                        this.state.answer4 === "yes" ||
                        this.state.answer4 === "no"
                      }
                      name="question1"
                      value="yes"
                      onChange={this.onValueChange1}
                      type="radio"
                      className="radio-btn-icon"
                    />
                    <span className="checkbox-label"> Yes </span>{" "}
                    <input
                      disabled={
                        this.state.answer2 === "yes" ||
                        this.state.answer2 === "no" ||
                        this.state.answer4 === "yes" ||
                        this.state.answer4 === "no"
                      }
                      name="question1"
                      value="no"
                      onChange={this.onValueChange1}
                      type="radio"
                      className="radio-btn-icon"
                    />
                    <span className="checkbox-label"> No </span>{" "}
                  </div>{" "}
                </div>{" "}
                {this.state.answer1 === "yes" ? (
                  <div>
                    <div>
                      <div className="question-block-label">
                        <label>
                          <ul>
                            <li>
                              If there is a basement, is the floor below the
                              elevation of the surrounding ground on all sides ?
                            </li>{" "}
                          </ul>{" "}
                        </label>{" "}
                      </div>{" "}
                      <div className="radio-btn-block">
                        <input
                          disabled={
                            this.state.answer3 === "yes" ||
                            this.state.answer3 === "no"
                          }
                          name="question2"
                          value="yes"
                          onChange={this.onValueChange2}
                          type="radio"
                          className="radio-btn-icon"
                        />
                        <span className="checkbox-label"> Yes </span>{" "}
                        <input
                          disabled={
                            this.state.answer1 === "yes" ||
                            this.state.answer1 === "no"
                          }
                          name="question2"
                          value="no"
                          onChange={this.onValueChange2}
                          type="radio"
                          className="radio-btn-icon"
                        />
                        <span className="checkbox-label"> No </span>{" "}
                      </div>{" "}
                    </div>{" "}
                  </div>
                ) : this.state.answer1 === "no" ? (
                  <div>
                    <div className="question-block-label">
                      <label>
                        <ul>
                          <li>
                            {" "}
                            Is the bottom floor of at least one side(excluding
                            the garage) at or above the elevation of the ground
                            adjacent to it ?
                          </li>{" "}
                        </ul>{" "}
                      </label>{" "}
                    </div>{" "}
                    <div className="radio-btn-block">
                      <input
                        disabled={
                          this.state.answer5 === "yes" ||
                          this.state.answer5 === "no" ||
                          this.state.answer7 === "yes" ||
                          this.state.answer7 === "no"
                        }
                        name="question4"
                        value="yes"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange4}
                      />{" "}
                      <span className="checkbox-label"> Yes </span>{" "}
                      <input
                        disabled={
                          this.state.answer5 === "yes" ||
                          this.state.answer5 === "no" ||
                          this.state.answer7 === "yes" ||
                          this.state.answer7 === "no"
                        }
                        name="question4"
                        value="no"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange4}
                      />{" "}
                      <span className="checkbox-label"> No </span>{" "}
                    </div>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer2 === "yes" ? (
                  <div>
                    <div className="question-block-label">
                      <label>
                        <ul>
                          <li>
                            If there is a basement or underground garage, is
                            most of the wall height of this floor and doorways
                            below the elevation of the surrounding ground ?{" "}
                          </li>{" "}
                        </ul>{" "}
                      </label>{" "}
                    </div>{" "}
                    <div className="radio-btn-block">
                      <input
                        disabled={
                          this.state.answer9 === "yes" ||
                          this.state.answer9 === "no" ||
                          this.state.answer6 === "yes" ||
                          this.state.answer6 === "no"
                        }
                        name="question3"
                        value="yes"
                        type="radio"
                        onChange={this.onValueChange3}
                        className="radio-btn-icon"
                      />
                      <span className="checkbox-label"> Yes </span>{" "}
                      <input
                        disabled={
                          this.state.answer9 === "yes" ||
                          this.state.answer9 === "no" ||
                          this.state.answer6 === "yes" ||
                          this.state.answer6 === "no"
                        }
                        name="question3"
                        value="no"
                        type="radio"
                        onChange={this.onValueChange3}
                        className="radio-btn-icon"
                      />
                      <span className="checkbox-label"> No </span>{" "}
                    </div>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer4 === "yes" ? (
                  <div>
                    <div className="question-block-label">
                      <label>
                        <ul>
                          <li>
                            Is the elevation of the bottom floor slab at the
                            same elevation as the surrounding ground ?{" "}
                          </li>{" "}
                        </ul>{" "}
                      </label>{" "}
                    </div>{" "}
                    <div className="radio-btn-block">
                      <input
                        disabled={
                          this.state.answer6 === "yes" ||
                          this.state.answer6 === "no" ||
                          this.state.answer9 === "yes" ||
                          this.state.answer9 === "no"
                        }
                        name="question5"
                        value="yes"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange5}
                      />{" "}
                      <span className="checkbox-label"> Yes </span>{" "}
                      <input
                        disabled={
                          this.state.answer6 === "yes" ||
                          this.state.answer6 === "no" ||
                          this.state.answer9 === "yes" ||
                          this.state.answer9 === "no"
                        }
                        name="question5"
                        value="no"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange5}
                      />{" "}
                      <span className="checkbox-label"> No </span>{" "}
                    </div>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer3 === "no" || this.state.answer5 == "yes" ? (
                  <div>
                    <div className="question-block-label">
                      <label>
                        <ul>
                          <li>
                            Is it a split - level building ? (there is a floor
                            that is not directly above or below another floor,
                            but middle floor is located at an elevation between
                            adjacent floors){" "}
                          </li>{" "}
                        </ul>{" "}
                      </label>{" "}
                    </div>{" "}
                    <div className="radio-btn-block">
                      <input
                        disabled={
                          this.state.answer9 === "yes" ||
                          this.state.answer9 === "no"
                        }
                        name="question6"
                        value="yes"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange6}
                      />{" "}
                      <span className="checkbox-label"> Yes </span>{" "}
                      <input
                        disabled={
                          this.state.answer9 === "yes" ||
                          this.state.answer9 === "no"
                        }
                        name="question6"
                        value="no"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange6}
                      />{" "}
                      <span className="checkbox-label"> No </span>{" "}
                    </div>{" "}
                  </div>
                ) : null}
                {this.state.answer4 === "no" ? (
                  <div>
                    <div className="question-block-label">
                      <label>
                        <ul>
                          <li>
                            Is the building on piers or on a shear
                            walls(permeable, where water and the elements may
                            pass through spaces between the supports for the
                            building above) ?{" "}
                          </li>{" "}
                        </ul>{" "}
                      </label>{" "}
                    </div>{" "}
                    <p>
                      {" "}
                      “In order for this answer to be‘ no’, then the structure
                      would need to have a first floor, basement, or garage at
                      or below surrounding ground elevation.Please review your
                      previous answers to see which diagrams fit these
                      descriptions.If the building does rest on piles or shear
                      walls and sit at or below ground level, then the answer
                      here is yes.”{" "}
                    </p>{" "}
                    <div className="radio-btn-block">
                      <input
                        disabled={
                          this.state.answer8 === "yes" ||
                          this.state.answer8 === "no"
                        }
                        name="question7"
                        value="yes"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange7}
                      />{" "}
                      <span className="checkbox-label"> Yes </span>
                      <input
                        disabled={
                          this.state.answer8 === "yes" ||
                          this.state.answer8 === "no" ||
                          this.state.answer4 === "no"
                        }
                        name="question7"
                        value="no"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChangeFalse}
                      />{" "}
                      <span className="checkbox-label"> No </span>{" "}
                    </div>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer7 === "yes" ? (
                  <div>
                    <div className="question-block-label">
                      <label>
                        <ul>
                          <li>
                            If the building is on piers or shear walls, is there
                            an enclosure at the ground level(i.e.entranceway,
                            enclosed storage area, etc.) ?{" "}
                          </li>{" "}
                        </ul>{" "}
                      </label>{" "}
                    </div>{" "}
                    <div className="radio-btn-block">
                      <input
                        disabled={
                          this.state.answer9 === "yes" ||
                          this.state.answer9 === "no"
                        }
                        name="question8"
                        value="yes"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange8}
                      />{" "}
                      <span className="checkbox-label"> Yes </span>{" "}
                      <input
                        disabled={
                          this.state.answer9 === "yes" ||
                          this.state.answer9 === "no"
                        }
                        name="question8"
                        value="no"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange8}
                      />{" "}
                      <span className="checkbox-label"> No </span>{" "}
                    </div>{" "}
                  </div>
                ) : this.state.answer7 === "no" ? (
                  <div className="sucess-statement">
                    <p> pleese enter valid answer </p>{" "}
                  </div>
                ) : null}
                {this.state.answer3 === "yes" ||
                this.state.answer6 === "yes" ||
                this.state.answer6 === "no" ||
                this.state.answer5 === "no" ||
                this.state.answer8 === "yes" ||
                this.state.answer8 === "no" ? (
                  <div>
                    <div className="question-block-label">
                      <label>
                        <ul>
                          <li>
                            Does the building have any floors above the ground
                            floor(2 nd Story or Split level) ?
                          </li>{" "}
                        </ul>{" "}
                      </label>{" "}
                    </div>{" "}
                    <div className="radio-btn-block">
                      <input
                        name="question9"
                        value="yes"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange9}
                      />{" "}
                      <span className="checkbox-label"> Yes </span>{" "}
                      <input
                        name="question9"
                        value="no"
                        type="radio"
                        className="radio-btn-icon"
                        onChange={this.onValueChange9}
                      />{" "}
                      <span className="checkbox-label"> No </span>{" "}
                    </div>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer2 === "yes" &&
                this.state.answer3 === "yes" &&
                (this.state.answer9 == "yes" || this.state.answer9 == "no") ? (
                  <div className="sucess-statement">
                    <h6> Building Diagram No: 2 B </h6>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer2 === "yes" &&
                this.state.answer3 === "no" &&
                this.state.answer6 === "yes" &&
                (this.state.answer9 == "yes" || this.state.answer9 == "no") ? (
                  <div className="sucess-statement">
                    <h6> Building Diagram No: 4 </h6>{" "}
                  </div>
                ) : this.state.answer3 === "no" &&
                  this.state.answer6 === "no" &&
                  (this.state.answer9 == "yes" ||
                    this.state.answer9 == "no") ? (
                  <div className="sucess-statement">
                    <h6> Building Diagram No: 2 A </h6>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer4 === "yes" &&
                this.state.answer5 === "yes" &&
                this.state.answer6 === "yes" &&
                (this.state.answer9 == "yes" || this.state.answer9 == "no") ? (
                  <div className="sucess-statement">
                    <h6> Building Diagram No: 3 </h6>{" "}
                  </div>
                ) : this.state.answer4 === "yes" &&
                  this.state.answer5 === "yes" &&
                  this.state.answer6 === "no" &&
                  (this.state.answer9 == "yes" ||
                    this.state.answer9 == "no") ? (
                  <div className="sucess-statement">
                    <h6> Building Diagram No: 1 A </h6>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer4 === "yes" &&
                this.state.answer5 === "no" &&
                (this.state.answer9 == "yes" || this.state.answer9 == "no") ? (
                  <div className="sucess-statement">
                    <h6> Building Diagram No: 1 B </h6>{" "}
                  </div>
                ) : null}{" "}
                {this.state.answer8 === "yes" &&
                (this.state.answer9 == "yes" || this.state.answer9 == "no") ? (
                  <div className="sucess-statement">
                    <h6> Building Diagram No: 6 </h6>{" "}
                  </div>
                ) : this.state.answer8 === "no" &&
                  (this.state.answer9 == "yes" ||
                    this.state.answer9 == "no") ? (
                  <div className="sucess-statement">
                    <h6> Building Diagram No: 5 </h6>{" "}
                  </div>
                ) : null}{" "}
                <div className="questionnaire-btn-section">
                  <button className="reset-btn" onChange={this.reset}>
                    Reset{" "}
                  </button>{" "}
                  {this.state.answer2 === "yes" &&
                  this.state.answer3 === "yes" &&
                  (this.state.answer9 == "yes" ||
                    this.state.answer9 == "no") ? (
                    <Link
                      className="next-step-button"
                      to={{
                        pathname: "/ElevationForm/" + userId,
                        diagram: "2B",
                        diagramData: this.state,
                      }}
                      onClick={() => this.setStorage("2B", this.state)}
                    >
                      Go to Form{" "}
                    </Link>
                  ) : null}{" "}
                  {this.state.answer2 === "yes" &&
                  this.state.answer3 === "no" &&
                  this.state.answer6 === "yes" &&
                  (this.state.answer9 == "yes" ||
                    this.state.answer9 == "no") ? (
                    <Link
                      className="next-step-button"
                      to={{
                        pathname: "/ElevationForm/" + userId,
                        diagram: "4",
                        diagramData: this.state,
                      }}
                      onClick={() => this.setStorage("4", this.state)}
                    >
                      Go to Form{" "}
                    </Link>
                  ) : this.state.answer3 === "no" &&
                    this.state.answer6 === "no" &&
                    (this.state.answer9 == "yes" ||
                      this.state.answer9 == "no") ? (
                    <Link
                      className="next-step-button"
                      to={{
                        pathname: "/ElevationForm/" + userId,
                        diagram: "2A",
                        diagramData: this.state,
                      }}
                      onClick={() => this.setStorage("2A", this.state)}
                    >
                      Go to Form{" "}
                    </Link>
                  ) : null}{" "}
                  {this.state.answer4 === "yes" &&
                  this.state.answer5 === "yes" &&
                  this.state.answer6 === "yes" &&
                  (this.state.answer9 == "yes" ||
                    this.state.answer9 == "no") ? (
                    <Link
                      className="next-step-button"
                      to={{
                        pathname: "/ElevationForm/" + userId,
                        diagram: "3",
                        diagramData: this.state,
                      }}
                      onClick={() => this.setStorage("3", this.state)}
                    >
                      Go to Form{" "}
                    </Link>
                  ) : this.state.answer4 === "yes" &&
                    this.state.answer5 === "yes" &&
                    this.state.answer6 === "no" &&
                    (this.state.answer9 == "yes" ||
                      this.state.answer9 == "no") ? (
                    <Link
                      className="next-step-button"
                      to={{
                        pathname: "/ElevationForm/" + userId,
                        diagram: "1A",
                        diagramData: this.state,
                      }}
                      onClick={() => this.setStorage("1A", this.state)}
                    >
                      Go to Form{" "}
                    </Link>
                  ) : null}{" "}
                  {this.state.answer4 === "yes" &&
                  this.state.answer5 === "no" &&
                  (this.state.answer9 == "yes" ||
                    this.state.answer9 == "no") ? (
                    <Link
                      className="next-step-button"
                      to={{
                        pathname: "/ElevationForm/" + userId,
                        diagram: "1B",
                        diagramData: this.state,
                      }}
                      onClick={() => this.setStorage("1B", this.state)}
                    >
                      Go to Form{" "}
                    </Link>
                  ) : null}{" "}
                  {this.state.answer8 === "yes" &&
                  (this.state.answer9 == "yes" ||
                    this.state.answer9 == "no") ? (
                    <Link
                      className="next-step-button"
                      to={{
                        pathname: "/ElevationForm/" + userId,
                        diagram: "6",
                        diagramData: this.state,
                      }}
                      onClick={() => this.setStorage("6", this.state)}
                    >
                      Go to Form{" "}
                    </Link>
                  ) : this.state.answer8 === "no" &&
                    (this.state.answer9 == "yes" ||
                      this.state.answer9 == "no") ? (
                    <Link
                      className="next-step-button"
                      to={{
                        pathname: "/ElevationForm/" + userId,
                        diagram: "5",
                        diagramData: this.state,
                      }}
                      onClick={() => this.setStorage("5", this.state)}
                    >
                      Go to Form{" "}
                    </Link>
                  ) : null}{" "}
                </div>{" "}
              </form>
            </div>
          ) : this.state.option === "no" ? (
            <div>
              <div className="headerCardRoot">
                <div className="headerCardMain cardHeading">
                  <div className="headerCardTitle">
                    <span> BUILDING DIAGRAM </span>{" "}
                  </div>
                </div>
              </div>

              <div className="conditional-question-form">
                <div className="radio-btn-back">
                  <input
                    type="radio"
                    id="radioBack"
                    name="option"
                    value=""
                    onChange={this.onSelcetOption}
                  />
                  <label for="radioBack">Go back</label>
                </div>
                <div className="diagram-section">
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "1A",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("1A", this.state)}
                  >
                    {" "}
                    <img
                      src="/static/images/diagrams/Diagram_1A.jpg"
                      className="single-diagram"
                    />
                  </Link>
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "1B",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("1B", this.state)}
                  >
                    {" "}
                    <img
                      src="/static/images/diagrams/Diagram_1B.jpg"
                      className="single-diagram"
                    />
                  </Link>
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "2A",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("2A", this.state)}
                  >
                    {" "}
                    <img
                      src="/static/images/diagrams/Diagram_2A.jpg"
                      className="single-diagram"
                    />
                  </Link>
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "2B",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("2B", this.state)}
                  >
                    <img
                      src="/static/images/diagrams/Diagram_2B.jpg"
                      className="single-diagram"
                    />
                  </Link>
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "3",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("3", this.state)}
                  >
                    <img
                      src="/static/images/diagrams/Diagram_3.jpg"
                      className="single-diagram"
                    />
                  </Link>{" "}
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "4",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("4", this.state)}
                  >
                    <img
                      src="/static/images/diagrams/Diagram_4.jpg"
                      className="single-diagram"
                    />
                  </Link>{" "}
                  <div className="question-block-label">
                    <span> * </span>{" "}
                    <label>
                      A floor that is below ground level(grade) on all sides is
                      considered a basement even if the floor is used for living
                      purposes, or as an office, garage, workshop, etc.{" "}
                    </label>{" "}
                  </div>
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "5",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("5", this.state)}
                  >
                    <img
                      src="/static/images/diagrams/Diagram_5.jpg"
                      className="single-diagram"
                    />
                  </Link>
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "6",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("6", this.state)}
                  >
                    <img
                      src="/static/images/diagrams/Diagram_6.jpg"
                      className="single-diagram"
                    />
                  </Link>
                  <Link
                    to={{
                      pathname: "/ElevationForm/" + userId,
                      diagram: "9",
                      diagramData: this.state,
                    }}
                    onClick={() => this.setStorage("9", this.state)}
                  >
                    <img
                      src="/static/images/diagrams/Diagram_9.jpg"
                      className="single-diagram"
                    />
                  </Link>{" "}
                  <div className="question-block-label">
                    <span> ** </span>{" "}
                    <label>
                      An "opening" is a permanent opening that allows for the
                      free passage of water automatically in both directions
                      without human intervention.Under the NFIP, a minimum of 2
                      openings is required for enclosures or crawlspaces.The
                      openings shall provide a total net area of not less than 1
                      square inch for every square foot of area enclosed,
                      excluding any bars, louvers, or other covers of the
                      opening.Alternatively, an Individual Engineered Flood
                      Openings Certification or an Evaluation Report issued by
                      the International Code Council Evaluation Service(ICC ES)
                      must be submitted to document that the design of the
                      openings will allow for the automatic equalization of
                      hydrostatic flood forces on exterior walls.A window, a
                      door, or a garage door is not considered an opening;
                      openings may be installed in doors.Openings shall be on at
                      least 2 sides of the enclosed area.If a building has more
                      than 1 enclosed area, each area must have openings to
                      allow floodwater to directly enter.The bottom of the
                      openings must be no higher than 1.0 foot above the higher
                      of the exterior or interior grade or floor immediately
                      below the opening.For more guidance on openings, see NFIP
                      Technical Bulletin 1.{" "}
                    </label>{" "}
                  </div>{" "}
                </div>{" "}
              </div>
            </div>
          ) : (
            ""
          )}
        </Container>{" "}
      </div>
    );
  }
}

Questionnaire.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Questionnaire);



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/Questionnaire.js